import * as React from 'react';

interface BooterProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const Booter = ({ children }: BooterProps) => {
  return <div className="modal-footer">{children}</div>;
};

export default Booter;
